import Artist from 'umg-ember-backend/components/record-explorer/for/artist';

<template><Artist @records={{@model}} @recordType='artist' /></template>
